import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import reducer from '../reducers/Reducer';
import prodLogger from './middleware/ProdLogger';
import utilService from '../services/UtilService';
import environmentNames from '../environmentNames';

function getMiddleware() {
    const middleware = [thunkMiddleware];
    if (process.env.NODE_ENV === environmentNames.UNIT_TESTING) {
        return middleware;
    }
    const dispatchLogLevel = utilService.getIntOr(utilService.getUrlParam('dispatchLogLevel'), 0);

    if (dispatchLogLevel === 1) {
        middleware.push(prodLogger);
    } else if (dispatchLogLevel === 2) {
        middleware.push(createLogger());
    }

    return middleware;
}

const createStoreWithMiddleware = applyMiddleware(...getMiddleware())(createStore);

const storeManager = {
    store: undefined,

    setStore(newStore) {
        this.store = newStore;
        return this;
    },

    getStore() {
        return this.store;
    },

    dispatch(action) {
        this.getStore().dispatch(action);
    },

    getState() {
        return this.getStore().getState();
    },

    configureStore(initialState = {}) {
        return createStoreWithMiddleware(reducer, initialState);
    },

    configureAndSetStore(initialState = {}) {
        const newStore = createStoreWithMiddleware(reducer, initialState);
        this.setStore(newStore);
        return newStore;
    },
};

export default storeManager;
